

























































import Vue from 'vue';
import debounce from 'lodash/debounce';

const $ = window.jQuery;

const updateResults = function () {
	var vm = this;

	if (this.missingTemplates.length || this.hasFilterFieldValue) {
		return;
	}

	this.loading = true;

	this.getPreviewResults().done(function (results) {
		vm.loading = false;
		vm.limit = results.limit;
		vm.results = results.results;
	}).fail(function () {
		vm.limit = null;
		vm.results = null;
		vm.loading = false;
	});
};

export default Vue.extend({
	data: function () {
		return {
			loading: false,
			previewResultsPromise: null,
			results: null,
			limit: null,
			gfBaseUrl: window.GPPA_ADMIN.gfBaseUrl,
			spinnerUrl: window.gf_global.spinnerUrl,
		};
	},
	created: function () {
		this.updateResults();
	},
	props: [
		'populate',
		'enabled',
		'field',
		'objectTypeInstance',
		'filterGroups',
		'templates',
		'templateRows',
		'orderingMethod',
		'orderingProperty',
		'uniqueResults',
	],
	watch: {
		filterGroups: {
			handler: function () {
				this.updateResultsDebounced();
			},
			deep: true,
		},
		templates: {
			handler: function () {
				this.updateResultsDebounced();
			},
			deep: true,
		},
		orderingProperty: function () {
			this.updateResults();
		},
		orderingMethod: function () {
			this.updateResults();
		},
		uniqueResults: function () {
			this.updateResults();
		},
		objectTypeInstance: function () {
			this.results = null;
		},
	},
	computed: {
		resultColumns: function () {
			if (!this.results || !this.results.length) {
				return [];
			}

			return Object.keys(this.results[0]);
		},
		hasFilterFieldValue: function () {

			var hasFilterFieldValue = false;

			this.filterGroups.forEach(function (filterGroup) {
				filterGroup.forEach(function (filter) {
					if (typeof filter.value === 'string' && filter.value.indexOf('gf_field') === 0) {
						hasFilterFieldValue = true;
					}
				});
			});

			return hasFilterFieldValue;

		},
		missingTemplates: function () {
			var vm = this;
			var missingTemplates = [];

			this.templateRows.forEach(function (templateRow) {
				if (!vm.templates?.[templateRow.id] && templateRow.required) {
					missingTemplates.push(templateRow.label);
				}
			});

			return missingTemplates;
		},
	},
	methods: {
		updateResults: updateResults,
		updateResultsDebounced: debounce(updateResults, 500),
		getPreviewResults: function () {
			if (this.previewResultsPromise && this.previewResultsPromise.state() !== 'resolved') {
				this.previewResultsPromise.abort();
			}

			this.previewResultsPromise = $.post(window.ajaxurl, {
				action: 'gppa_get_query_results',
				templateRows: this.templateRows,
				gppaPopulate: this.populate,
				fieldSettings: JSON.stringify(window.field),
				security: window.GPPA_ADMIN.nonce,
			}, null, 'json');

			return this.previewResultsPromise;
		},
	}
});
